<template>
  <div class="page flex-col">
    <!-- 移动端提示弹窗 -->
    <el-dialog
      :visible="mobileDialogVisible"
      title="提示"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="400px"
      center
      custom-class="mobile-warning-dialog"
      @close="preventClose"
    >
      <div style="text-align: center; padding: 20px 0;">
        <i class="el-icon-warning" style="font-size: 48px; color: #E6A23C; margin-bottom: 20px;"></i>
        <p style="font-size: 16px; color: #606266;">请在电脑端打开网站</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 不显示任何按钮，弹窗无法关闭 -->
      </span>
    </el-dialog>
    <div class="section_1 flex-col">
      <div class="main-card">
        <!-- 左侧视觉区域 -->
        <div class="left-section">
          <div class="brand-logo">
            <div class="logo-icon"></div>
            <span class="brand-text">笔试助聘网</span>
          </div>
          <!-- 插画区域 -->
          <div class="illustration-area">
          </div>
        </div>
        <!-- 右侧表单区域 -->
        <div class="right-section">
          <el-tabs v-model="activeTab" class="custom-tabs" @tab-click="handleTabClick">
            <el-tab-pane name="interviewer">
              <template #label>
                <span class="tab-label" :class="{ active: activeTab === 'interviewer' }">面试人员</span>
              </template>
            </el-tab-pane>
            <el-tab-pane name="company">
              <template #label>
                <span class="tab-label" :class="{ active: activeTab === 'company' }">公司入驻</span>
              </template>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-model="activeTab" class="content-tabs">
            <el-tab-pane name="interviewer">
              <div class="form-container">
                <div class="form-item">
                  <span class="form-label">公司</span>
                  <el-select
                    v-model="form.companyName"
                    placeholder="请选择公司"
                    class="form-input"
                    size="medium"
                    filterable
                  >
                    <el-option
                      v-for="item in companyList"
                      :key="item.id"
                      :label="item.companyName"
                      :value="item.companyName"
                    ></el-option>
                  </el-select>
                </div>
                <div class="form-item">
                  <span class="form-label">姓名</span>
                  <el-input
                    v-model="form.username"
                    placeholder="请输入姓名"
                    class="form-input"
                    size="medium"
                    @keyup.enter.native="handleLogin"
                  ></el-input>
                </div>
                <div class="form-item">
                  <span class="form-label">手机号</span>
                  <el-input
                    v-model="form.password"
                    type="text"
                    placeholder="请输入手机号"
                    class="form-input"
                    size="medium"
                    @keyup.enter.native="handleLogin"
                  ></el-input>
                </div>
                <div class="form-item">
                  <el-button
                    type="primary"
                    class="submit-button"
                    size="medium"
                    :loading="loginLoading"
                    @click="handleLogin"
                  >
                    <span>确定</span>
                  </el-button>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="company">
              <div class="form-container">
                <div class="form-item">
                  <span class="form-label">公司名字</span>
                  <el-input
                    v-model="companyForm.companyName"
                    placeholder="请输入"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </div>
                <div class="form-item">
                  <span class="form-label">手机号</span>
                  <el-input
                    v-model="companyForm.userPhone"
                    placeholder="请输入手机号"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </div>
                <div class="form-item">
                  <el-button
                    type="primary"
                    class="submit-button"
                    size="medium"
                    :loading="submitting"
                    @click="handleSubmit"
                  >
                    <span>提交</span>
                  </el-button>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCompanyList, createExamCompany, hasNatureExam } from '@/api/exam'
import { login, getTenantIdByName, getTenantByWebsite, getUserInfo as getUserInfoApi } from '@/api/login'
import { setToken, setLoginForm, removeLoginForm, setTenantId, getTenantId, getLoginForm, setUserInfo, setCompanyInfo } from '@/utils/auth'

export default {
  data() {
    return {
      activeTab: 'interviewer', // 当前激活的tab，默认是面试者
      loginLoading: false,
      submitting: false,
      companyList: [], // 公司列表
      mobileDialogVisible: false, // 移动端提示弹窗显示状态
      form: {
        companyName: '',
        username: process.env.VUE_APP_DEFAULT_LOGIN_USERNAME || '',
        password: process.env.VUE_APP_DEFAULT_LOGIN_PASSWORD || '',
        phone: '',
        rememberMe: true,
        tenantName: process.env.VUE_APP_DEFAULT_LOGIN_TENANT || ''
      },
      companyForm: {
        companyName: '',
        userPhone: ''
      },
      tenantEnable: (process.env.VUE_APP_TENANT_ENABLE || 'false') === 'true'
    };
  },
  mounted() {
    // 检测是否为PC端
    this.checkDevice()
    // 获取缓存的登录信息
    this.getLoginFormCache()
    // 根据域名获取租户信息
    this.getTenantByWebsite()
    // 页面加载时获取公司列表
    this.fetchCompanyList();
  },
  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('keydown', this.preventDialogClose, true)
    // 恢复页面滚动
    document.body.style.overflow = ''
  },
  methods: {
    // 检测是否为PC端
    checkDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // 移动设备检测正则
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
      // 屏幕宽度检测（小于768px通常认为是移动设备）
      const isMobileWidth = window.innerWidth < 768
      // 触摸支持检测
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

      // 判断是否为移动设备
      const isMobile = mobileRegex.test(userAgent) || (isMobileWidth && isTouchDevice)

      if (isMobile) {
        // 显示无法关闭的提示弹窗
        this.mobileDialogVisible = true
        // 阻止弹窗关闭的所有方式
        this.$nextTick(() => {
          // 移除关闭按钮
          const closeBtn = document.querySelector('.mobile-warning-dialog .el-dialog__close')
          if (closeBtn) {
            closeBtn.style.display = 'none'
          }
          // 阻止ESC键关闭
          document.addEventListener('keydown', this.preventDialogClose, true)
          // 确保遮罩层完全覆盖
          this.ensureModalCoverage()
        })
      }
    },
    // 阻止弹窗关闭
    preventDialogClose(e) {
      if (e.key === 'Escape' && this.mobileDialogVisible) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
    // 阻止弹窗关闭事件
    preventClose() {
      // 如果弹窗被尝试关闭，立即重新打开
      this.$nextTick(() => {
        this.mobileDialogVisible = true
        this.ensureModalCoverage()
      })
    },
    // 确保遮罩层完全覆盖页面
    ensureModalCoverage() {
      this.$nextTick(() => {
        // 设置遮罩层样式
        const vModal = document.querySelector('.v-modal')
        if (vModal) {
          vModal.style.position = 'fixed'
          vModal.style.top = '0'
          vModal.style.left = '0'
          vModal.style.width = '100%'
          vModal.style.height = '100%'
          vModal.style.zIndex = '9998'
          vModal.style.backgroundColor = '#000000'
        }
        // 设置弹窗包装器样式
        const dialogWrapper = document.querySelector('.el-dialog__wrapper')
        if (dialogWrapper) {
          dialogWrapper.style.position = 'fixed'
          dialogWrapper.style.top = '0'
          dialogWrapper.style.left = '0'
          dialogWrapper.style.right = '0'
          dialogWrapper.style.bottom = '0'
          dialogWrapper.style.zIndex = '9999'
        }
        // 阻止页面滚动
        document.body.style.overflow = 'hidden'
      })
    },
    // 手机号正则校验
    validatePhone(phone) {
      // 中国手机号正则：1开头，第二位是3-9，共11位数字
      const phoneReg = /^1[3-9]\d{9}$/
      return phoneReg.test(phone)
    },
    // 获取缓存的登录表单
    getLoginFormCache() {
      const loginForm = getLoginForm()
      if (loginForm) {
        this.form = {
          ...this.form,
          username: loginForm.username || this.form.username,
          password: loginForm.password || this.form.password,
          rememberMe: loginForm.rememberMe !== undefined ? loginForm.rememberMe : this.form.rememberMe,
          tenantName: loginForm.tenantName || this.form.tenantName
        }
      }
    },
    // 根据域名获取租户信息
    async getTenantByWebsite() {
      if (this.tenantEnable) {
        try {
          const website = location.host
          const res = await getTenantByWebsite(website)
          if (res) {
            // res 已经是后端返回的数据（可能是对象或数字）
            if (typeof res === 'object' && res.name) {
              this.form.tenantName = res.name
              setTenantId(res.id)
            }
          }
        } catch (error) {
          console.error('获取租户信息失败:', error)
        }
      }
    },
    // 获取租户ID
    async getTenantId() {
      if (this.tenantEnable && this.form.tenantName) {
        try {
          const res = await getTenantIdByName(this.form.tenantName)
          if (res !== undefined && res !== null) {
            // res 可能是数字（租户ID）或对象
            const tenantId = typeof res === 'object' ? res.id : res
            if (tenantId) {
              setTenantId(tenantId)
            }
          }
        } catch (error) {
          console.error('获取租户ID失败:', error)
          throw error
        }
      }
    },
    // 获取公司列表
    async fetchCompanyList() {
      try {
        const res = await getCompanyList();
        // request.js 拦截器已经处理了响应，如果 code === 0，会返回 res.data
        // 如果直接返回数组，则 res 就是数组；如果返回对象，则 res.data 是数组
        console.log(res);
        if (Array.isArray(res)) {
          this.companyList = res;
        } else if (res && Array.isArray(res.data)) {
          this.companyList = res.data;
        } else if (res && res.data && Array.isArray(res.data)) {
          this.companyList = res.data;
        }
      } catch (error) {
        console.error('获取公司列表失败:', error);
        this.$message.error('获取公司列表失败');
      }
    },
    handleTabClick(tab) {
      // Tab 切换时的处理逻辑
      console.log('切换到:', tab.name);
    },
    // 登录（面试者tab）
    async handleLogin() {
      // 表单验证
      if (!this.form.companyName) {
        this.$message.warning('请选择公司')
        return
      }
      if (!this.form.username) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!this.form.password) {
        this.$message.warning('请输入手机号')
        return
      }
      // 手机号格式校验
      if (!this.validatePhone(this.form.password)) {
        this.$message.warning('请输入正确的手机号格式')
        return
      }

      this.loginLoading = true
      const loading = this.$loading({
        lock: true,
        text: '正在登录...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        // 获取租户ID（如果租户功能未开启，设置默认值 1）
        await this.getTenantId()
        // 确保租户ID已设置（如果没有，设置默认值 1）
        if (!getTenantId()) {
          setTenantId('1')
        }

        // 调用登录API
        const loginData = {
          username: this.form.username,
          password: this.form.password,
          tenantName: '芋道源码',
          rememberMe: true
        }

        const res = await login(loginData)

        if (res) {
          // 保存token（res 已经是 token 对象，因为 request.js 的响应拦截器已经处理）
          setToken(res)

          // 缓存公司信息
          const selectedCompany = this.companyList.find(item => item.companyName === this.form.companyName)
          if (selectedCompany) {
            try {
              setCompanyInfo(selectedCompany)
            } catch (error) {
              console.error('缓存公司信息失败:', error)
              // 如果函数调用失败，直接使用 localStorage
              localStorage.setItem('COMPANY_INFO', JSON.stringify(selectedCompany))
            }
          }

          // 获取用户信息并缓存
          try {
            const userInfo = await getUserInfoApi()
            if (userInfo) {
              setUserInfo(userInfo)
            }
          } catch (error) {
            console.error('获取用户信息失败:', error)
            // 即使获取用户信息失败，也不影响登录流程
          }

          // 记住我
          if (this.form.rememberMe) {
            setLoginForm({
              username: this.form.username,
              password: this.form.password,
              rememberMe: this.form.rememberMe,
              tenantName: this.form.tenantName
            })
          } else {
            removeLoginForm()
          }

          this.$message.success('登录成功')

          // 判断是否参加过性格考试
          try {
            const participated = await hasNatureExam()
            if (participated === true) {
              const redirect = this.$route.query.redirect || '/index'
              this.$router.push(redirect)
            } else {
              this.$router.push('/exam/nature')
            }
          } catch (e) {
            console.error('检查性格考试状态失败', e)
            const redirect = this.$route.query.redirect || '/index'
            this.$router.push(redirect)
          }
        }
      } catch (error) {
        console.error('登录失败:', error)
        // 错误信息已在 request.js 的拦截器中处理
      } finally {
        this.loginLoading = false
        loading.close()
      }
    },
    // 提交（公司入驻tab）
    async handleSubmit() {
      if (!this.companyForm.companyName) {
        this.$message.warning('请输入公司名字');
        return;
      }
      if (!this.companyForm.userPhone) {
        this.$message.warning('请输入手机号');
        return;
      }
      // 手机号格式校验
      if (!this.validatePhone(this.companyForm.userPhone)) {
        this.$message.warning('请输入正确的手机号格式');
        return;
      }

      this.submitting = true;
      const loading = this.$loading({
        lock: true,
        text: '正在提交...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        const submitData = {
          companyName: this.companyForm.companyName,
          userPhone: this.companyForm.userPhone,
          status: 0 // 0:未启用，等待管理员审核
        };

        const res = await createExamCompany(submitData);

        if (res) {
          this.$message.success('提交成功，请等待管理员审核');
          // 清空表单
          this.companyForm = {
            companyName: '',
            userPhone: ''
          };
          // 刷新公司列表
          await this.fetchCompanyList();
        }
      } catch (error) {
        console.error('公司入驻失败:', error);
        // 错误信息已在 request.js 的拦截器中处理
      } finally {
        this.submitting = false;
        loading.close();
      }
    }
  }
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />
<style lang="scss">
// 移除 tab-pane 选中后的下划线
.custom-tabs {
  ::v-deep .el-tabs__active-bar {
    display: none !important;
  }
  ::v-deep .el-tabs__item.is-active {
    border-bottom: none !important;
  }
}

// 移动端提示弹窗样式 - 确保完全遮盖页面
.mobile-warning-dialog {
  z-index: 10000 !important;
}

// 遮罩层样式 - 确保完全覆盖整个页面
.el-dialog__wrapper {
  &.mobile-warning-dialog-wrapper {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 9999 !important;
  }
}

// 确保遮罩层覆盖整个视口
body.el-popup-parent--hidden {
  overflow: hidden !important;
}

// 当弹窗显示时，确保遮罩层完全覆盖
.v-modal {
//   z-index: 9998 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background-color: #000000 !important;
}
</style>
